import { GenericVideoApplianceType } from './api/model/applianceRegistration'
import { ApplianceType, ApplianceVariant } from './api/v1/types'

export type VaApplianceType =
    | ApplianceType.nimbraVA220
    | ApplianceType.nimbraVA225
    | ApplianceType.nimbra410
    | ApplianceType.nimbra412
    | ApplianceType.nimbra414
    | ApplianceType.nimbra414b
    | ApplianceType.nimbraVAdocker

export function isVaApplianceType(applianceType: ApplianceType): applianceType is VaApplianceType {
    return [
        ApplianceType.nimbraVA220,
        ApplianceType.nimbraVA225,
        ApplianceType.nimbra410,
        ApplianceType.nimbra412,
        ApplianceType.nimbra414,
        ApplianceType.nimbra414b,
        ApplianceType.nimbraVAdocker,
    ].includes(applianceType)
}

export function isMatroxApplianceType(
    applianceType: ApplianceType
): applianceType is
    | ApplianceType.matroxMonarchEdgeE4_8Bit
    | ApplianceType.matroxMonarchEdgeE4_10Bit
    | ApplianceType.matroxMonarchEdgeD4
    | ApplianceType.matroxMonarchEdgeS1 {
    return [
        ApplianceType.matroxMonarchEdgeE4_8Bit,
        ApplianceType.matroxMonarchEdgeE4_10Bit,
        ApplianceType.matroxMonarchEdgeD4,
        ApplianceType.matroxMonarchEdgeS1,
    ].includes(applianceType)
}

export function isGenericVideoApplianceType(applianceType: ApplianceType): applianceType is GenericVideoApplianceType {
    return (
        applianceType === ApplianceType.riversilica ||
        applianceType === ApplianceType.nimbra204 ||
        applianceType === ApplianceType.edgeSdi
    )
}

export function isNimbra414EdgeSdiApplianceVariant(applianceVariant: ApplianceVariant | undefined): boolean {
    return applianceVariant === ApplianceVariant.nimbra414 || applianceVariant === ApplianceVariant.nimbra414b
}

/** The code identifier `nimbra414` means revision A specifically; revision B is `nimbra414b`. */
export function isNimbra414aEdgeSdiApplianceVariant(applianceVariant: ApplianceVariant | undefined): boolean {
    return applianceVariant === ApplianceVariant.nimbra414
}

export function isNimbra414bEdgeSdiApplianceVariant(applianceVariant: ApplianceVariant | undefined): boolean {
    return applianceVariant === ApplianceVariant.nimbra414b
}

export function applianceTypeSupportsTransformation(applianceType: ApplianceType): boolean {
    return (
        applianceType === ApplianceType.core ||
        applianceType === ApplianceType.edgeConnect ||
        applianceType === ApplianceType.edgeSdi
    )
}

export function applianceTypeSupportsMultipleLogicalPorts(applianceType: ApplianceType): boolean {
    return (
        applianceType === ApplianceType.core ||
        applianceType === ApplianceType.edgeConnect ||
        applianceType === ApplianceType.edgeSdi
    )
}

export function applianceTypeSupportsMptsDemux(applianceType: ApplianceType): boolean {
    return (
        applianceType !== ApplianceType.thumb &&
        !isVaApplianceType(applianceType) &&
        !isMatroxApplianceType(applianceType)
    )
}
